import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ConfirmProvider } from './components/ConfirmProvider';
import { Toaster } from './components/ui/sonner';
import ProtectedRoute from './components/ProtectedRoute';
import ErrorBoundary from './components/ErrorBoundary';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Keys from './pages/Keys';
import Printing from './pages/Printing';
import BusinessCards from './pages/BusinessCards';
import Binding from './pages/Binding';
import ITProducts from './pages/ITProducts';
import Clients from './pages/Clients';
import Invoices from './pages/Invoices';
import Users from './pages/Users';
import StockMovements from './pages/StockMovements';
import Quotes from './pages/Quotes';
import Settings from './pages/Settings';
import CashRegister from './pages/CashRegister';
import Services from './pages/Services';
import CreditNotes from './pages/CreditNotes';
import ServiceReport from './pages/ServiceReport';
import AccountingExports from './pages/AccountingExports';
import Interventions from './pages/Interventions';
import StockView from './pages/StockView';
import SAV from './pages/SAV';
import InterventionMap from './pages/InterventionMap';
import Pertes from './pages/Pertes';
import Suppliers from './pages/Suppliers';
import Prestations from './pages/Prestations';
import CounterSales from './pages/CounterSales';
import './App.css';

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <ConfirmProvider>
          <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <ProtectedRoute allowedRoles={["admin", "seller"]}>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/keys"
            element={
              <ProtectedRoute>
                <Keys />
              </ProtectedRoute>
            }
          />
          <Route
            path="/printing"
            element={
              <ProtectedRoute>
                <Printing />
              </ProtectedRoute>
            }
          />
          <Route
            path="/business-cards"
            element={
              <ProtectedRoute>
                <BusinessCards />
              </ProtectedRoute>
            }
          />
          <Route
            path="/binding"
            element={
              <ProtectedRoute>
                <Binding />
              </ProtectedRoute>
            }
          />
          <Route
            path="/it-products"
            element={
              <ProtectedRoute>
                <ITProducts />
              </ProtectedRoute>
            }
          />
          <Route
            path="/clients"
            element={
              <ProtectedRoute>
                <Clients />
              </ProtectedRoute>
            }
          />
          <Route
            path="/invoices"
            element={
              <ProtectedRoute>
                <Invoices />
              </ProtectedRoute>
            }
          />
          <Route
            path="/counter-sales"
            element={
              <ProtectedRoute allowedRoles={["admin", "seller"]}>
                <CounterSales />
              </ProtectedRoute>
            }
          />
          <Route
            path="/users"
            element={
              <ProtectedRoute adminOnly>
                <Users />
              </ProtectedRoute>
            }
          />
          <Route
            path="/stock-movements"
            element={
              <ProtectedRoute>
                <StockMovements />
              </ProtectedRoute>
            }
          />
          <Route
            path="/quotes"
            element={
              <ProtectedRoute>
                <Quotes />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <ProtectedRoute adminOnly>
                <Settings />
              </ProtectedRoute>
            }
          />
          <Route
            path="/cash-register"
            element={
              <ProtectedRoute>
                <CashRegister />
              </ProtectedRoute>
            }
          />
          <Route
            path="/services"
            element={
              <ProtectedRoute>
                <Services />
              </ProtectedRoute>
            }
          />
          <Route
            path="/credit-notes"
            element={
              <ProtectedRoute>
                <CreditNotes />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reports/services"
            element={
              <ProtectedRoute>
                <ServiceReport />
              </ProtectedRoute>
            }
          />
          <Route
            path="/accounting/exports"
            element={
              <ProtectedRoute adminOnly>
                <AccountingExports />
              </ProtectedRoute>
            }
          />
          <Route
            path="/interventions"
            element={
              <ProtectedRoute allowedRoles={["admin", "seller", "technician"]}>
                <Interventions />
              </ProtectedRoute>
            }
          />
          <Route
            path="/stock-view"
            element={
              <ProtectedRoute allowedRoles={["technician", "admin"]}>
                <StockView />
              </ProtectedRoute>
            }
          />
          <Route
            path="/sav"
            element={
              <ProtectedRoute allowedRoles={["admin", "seller"]}>
                <SAV />
              </ProtectedRoute>
            }
          />
          <Route
            path="/interventions-map"
            element={
              <ProtectedRoute allowedRoles={["technician", "admin"]}>
                <InterventionMap />
              </ProtectedRoute>
            }
          />
          <Route
            path="/pertes"
            element={
              <ProtectedRoute allowedRoles={["admin", "seller"]}>
                <Pertes />
              </ProtectedRoute>
            }
          />
          <Route
            path="/suppliers"
            element={
              <ProtectedRoute allowedRoles={["admin", "seller"]}>
                <Suppliers />
              </ProtectedRoute>
            }
          />
          <Route
            path="/prestations"
            element={
              <ProtectedRoute allowedRoles={["admin", "seller"]}>
                <Prestations />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" />
        </ConfirmProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;